export default __webpack_public_path__ + "static/media/correctAnswer.2c237451.svg";